import { render, staticRenderFns } from "./organ_device_bind.vue?vue&type=template&id=1975b3ad"
import script from "./organ_device_bind.vue?vue&type=script&lang=js"
export * from "./organ_device_bind.vue?vue&type=script&lang=js"
import style0 from "./organ_device_bind.vue?vue&type=style&index=0&id=1975b3ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports